import { autoinject } from 'aurelia-framework';
import { ComponentBase } from 'app/shared/lib/essette-site';

@autoinject()
export class DemoEssRibbonLink extends ComponentBase {

    ////****************** Lifecycle events (in order of execution) *****************////
    constructor(...rest: any[]) {
        super(...rest);
    }

    ////****************** Example 1 ********************************************////

    protected generateTabLink(): string {
        const parentUrl = this.router.parent.generate('demo');
        return parentUrl;
    }

    ////****************** Example 2 ********************************************////
    protected ex2Url: string = '/#/demo';
    protected ex2Tooltip: string | null = 'Demo Home Page';

}
